module.exports = __webpack_public_path__ + "img/input.288bddd4.svg";